import { Component, OnInit, Renderer2, Input } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormArray,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

import { VariantTypeService } from '@app/core/variant-types/services/variant-type.service';

@Component({
  selector: 'cnc-rfq-form-variants',
  templateUrl: './rfq-form-variants.component.html',
  styleUrls: ['./rfq-form-variants.component.scss'],
})
export class RfqFormVariantsComponent implements OnInit {
  loading :boolean = false;
  submitted :boolean = false;
  pageTitle :string = this.translate.instant('TITLES.ADD_PRODUCT_VARIANT'); //'Add Product Variant';
  formData :UntypedFormGroup;

  variantTypes :any = [];

  @Input() variant :any;
  @Input() selectedVariants :any;

  constructor(
    public activeModal :NgbActiveModal,
    private formBuilder :UntypedFormBuilder,
    private renderer :Renderer2,
    private translate :TranslateService,
    public variantTypeSvc :VariantTypeService,
  ) {}

  ngOnInit() {
    this.formData = this.formBuilder.group({
      variant_name: ['', Validators.required],
      variant_terms: this.formBuilder.array([]),
    });
    if (this.variant) {
      this.formData.patchValue(this.variant);
      const terms = this.formData.get('variant_terms') as UntypedFormArray;
      this.variant.variant_terms?.forEach((v) => {
        terms.push(this.formBuilder.control(v));
      });
    } else {
      this.addVariant();
    }

    this.variantTypeSvc.record$.subscribe((types) => {
      const selectedVariants = this.selectedVariants.map((e) => e.variant_name);
      this.variantTypes = types.filter((e) => !selectedVariants.includes(e.name));
    });
  }

  submit() {
    if (!this.formData.valid) {
      Swal.fire({
        title: this.translate.instant('MESSAGES.FORM_ERROR.TITLE'),
        text: this.translate.instant('MESSAGES.FORM_ERROR.TEXT'),
        type: 'error',
        confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
      });

      return;
    }
    const terms = [];
    this.formData.value.variant_terms.forEach((term) => {
      if (term && term.trim().length > 0) {
        terms.push(term);
      }
    });
    if (terms.length == 0) {
      Swal.fire({
        title: this.translate.instant('MESSAGES.FORM_ERROR.TITLE'),
        text: this.translate.instant('MESSAGES.VARIANT_TERM_REQUIRED'),
        type: 'error',
        confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
      });

      return;
    }
    const data = this.formData.value;
    data.variant_terms = terms;
    this.submitted = true;
    this.activeModal.close(data);
  }
  addVariant(idx ?:number) {
    if (!idx) {
      idx = this.formData.value.variant_terms.length;
    }
    const terms = this.formData.get('variant_terms') as UntypedFormArray;
    terms.push(this.formBuilder.control(''));
    setTimeout(() => {
      const element = this.renderer.selectRootElement('#term' + idx.toString());
      setTimeout(() => {
        element.focus();
        element.select();
      }, 0);
    }, 0);
  }

  addTagFn() {
    return (term) => {
      return {
        id: 0,
        name: term,
      };
    };
  }

  trackByFn(item :any) {
    return item.id;
  }
}
